document.addEventListener('DOMContentLoaded', function () {
    const canvas = document.getElementById("snowCanvas");
    const ctx = canvas.getContext("2d");

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Valentine elements (image URLs)
    const valentineItems = [
        "https://cdn.shopify.com/s/files/1/0734/0366/2650/files/rose-7.png",
        "https://cdn.shopify.com/s/files/1/0734/0366/2650/files/rose-2.png",
        "https://cdn.shopify.com/s/files/1/0734/0366/2650/files/rose-1.png",
        "https://cdn.shopify.com/s/files/1/0734/0366/2650/files/rose-4.png",
        "https://cdn.shopify.com/s/files/1/0734/0366/2650/files/rose-3.png"
    ];

    const particles = [];
    let numParticles = getParticleCount();
    let sizeRange = getParticleSize();

    class ValentineParticle {
        constructor() {
            this.reset();
            this.symbol = valentineItems[Math.floor(Math.random() * valentineItems.length)];
            this.img = new Image();
            this.img.src = this.symbol;  // Load the image from the URL
        }

        reset() {
            this.x = Math.random() * canvas.width;
            this.y = Math.random() * canvas.height;
            this.size = Math.random() * (sizeRange[1] - sizeRange[0]) + sizeRange[0];
            this.speedY = Math.random() * 0.6 + 0.3;   // soft fall
            this.speedX = Math.random() * 0.4 - 0.2;   // gentle float
        }

        update() {
            this.y += this.speedY;
            this.x += this.speedX;

            if (this.y > canvas.height) {
                this.y = -this.size;
                this.x = Math.random() * canvas.width;
            }

            if (this.x > canvas.width || this.x < 0) {
                this.speedX *= -1;
            }
        }

        draw() {
            ctx.drawImage(this.img, this.x, this.y, this.size, this.size);  // Draw the image

        }
    }

    function getParticleCount() {
        return window.innerWidth <= 768 ? 8 : 20;
    }

    function getParticleSize() {
        return window.innerWidth <= 768 ? [14, 26] : [20, 38];
    }

    function generateParticles() {
        numParticles = getParticleCount();
        sizeRange = getParticleSize();
        particles.length = 0;

        for (let i = 0; i < numParticles; i++) {
            particles.push(new ValentineParticle());
        }
    }

    function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        particles.forEach(p => {
            p.update();
            p.draw();
        });

        requestAnimationFrame(animate);
    }

    generateParticles();
    animate();

    window.addEventListener('resize', () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        generateParticles();
    });
});








console.log("progress bar v3 loaded");

// Fetch Cart
function getCartData() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(data => {
      let totalQuantity = data.items.reduce((total, item) => total + item.quantity, 0);
      updateProgressBar(totalQuantity);
    })
    .catch(err => console.error("Cart Fetch Error:", err));
}

// Update Bar
function updateProgressBar(cartQuantity) {

  const step1 = 1; // Step 1: 1 product
  const step2 = 2; // Step 2: 2 products
  const step3 = 3; // Step 3: 3 products

  let progressWidth = "0%";
  let offerText = "";

  // Show progress bar instead of note
  $('.progress-note').hide();
  $('.progress-container-bg-color, .progress_offer_wrap').show();

  // Remove all active states
  $('.circle').removeClass('active');

  // STEP LOGIC
  if (cartQuantity < step1) {
    progressWidth = "0%";
    offerText = `Add ${step1 - cartQuantity} more product to unlock Gift 1`;
  }

  else if (cartQuantity >= step1 && cartQuantity < step2) {
    progressWidth = "33%";
    offerText = "Congrats! You unlocked Gift 1!";
    $('.circle:nth-child(2)').addClass('active'); 
  }

  else if (cartQuantity >= step2 && cartQuantity < step3) {
    progressWidth = "66%";
    offerText = "Awesome! You unlocked Gift 1 & Gift 2!";
    $('.circle:nth-child(2), .circle:nth-child(3)').addClass('active');
  }

  else if (cartQuantity >= step3) {
    progressWidth = "100%";
    offerText = "You unlocked ALL gifts! Gift 1 + Gift 2 + Gift 3!";
    $('.circle').addClass('active');
  }

  // Apply progress width
  $('#progress').css({ width: progressWidth });

  // Update text
  $('.progress_offer_wrap p').text(offerText);
}

// Start
$(document).ready(function () {
  getCartData();
  setInterval(getCartData, 1500); // refresh every 1.5 sec
});
